import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-submenu_down",
  "use": "icon-submenu_down-usage",
  "viewBox": "0 0 7.583 3.799",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7.583 3.799\" id=\"icon-submenu_down\">\r\n  <defs>\r\n  </defs>\r\n  <path id=\"icon-submenu_down_下\" class=\"cls-1\" d=\"M69.316,281.9l3.342-2.941a.413.413,0,0,0,.026-.6.454.454,0,0,0-.629-.025l-3.043,2.678-3.047-2.683a.459.459,0,0,0-.629.029.417.417,0,0,0,.03.6l3.346,2.937c.009,0,.013.013.022.017A.451.451,0,0,0,69.316,281.9Z\" transform=\"translate(-65.22 -278.212)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol